// El boton "Paga con transferencia" es <scala-cart-button> (app Scala) y renderiza
// en Shadow DOM abierto: el CSS del theme no entra. Se inyecta una hoja de estilos
// dentro del shadow para igualar la tipografia a los otros botones del drawer.
(function () {
  // Estilos inline con prioridad important: la hoja propia de Scala tambien usa
  // !important y con mayor especificidad, asi que una stylesheet inyectada no alcanza.
  const FONT_PROPS = [
    ['font-size', '13px'],
    ['font-weight', '700'],
    ['letter-spacing', '0.03em'],
    ['text-transform', 'uppercase'],
    ['line-height', '1.2'],
    ['height', '48px'],
    ['min-height', '48px'],
    ['padding', '12px 16px'],
    ['background-color', '#15803d'],
    ['border-color', '#15803d'],
    ['color', '#ffffff']
  ];

  const setProps = (el) => {
    FONT_PROPS.forEach(([prop, value]) => el.style.setProperty(prop, value, 'important'));
  };

  // Un script custom configurado dentro de la app Scala re-setea font-size:10px/height:40px
  // inline (era para el layout viejo de una fila). Guardia con patron anti-eco:
  // se desconecta el observer antes de re-aplicar para no observar las propias mutaciones.
  const guardEl = (el) => {
    if (el.dataset.collinoFontGuard === 'true') return;
    el.dataset.collinoFontGuard = 'true';
    setProps(el);
    const obs = new MutationObserver(() => {
      if (el.style.getPropertyValue('font-size') === '13px') return;
      obs.disconnect();
      setProps(el);
      obs.observe(el, { attributes: true, attributeFilter: ['style'] });
    });
    obs.observe(el, { attributes: true, attributeFilter: ['style'] });
  };

  // Colapsa el hueco reservado del boton de transferencia. Se llama al detectar
  // el boton (el intercambio hueco->boton es a cero movimiento porque miden lo
  // mismo) y tambien al terminar el barrido sin encontrarlo, para no dejar un
  // hueco permanente si la app se desinstala.
  const resolveSlot = () => {
    document.querySelectorAll('[data-cart-drawer-buttons]').forEach((c) => {
      c.classList.add('scala-resolved');
    });
  };

  const applyFix = () => {
    document.querySelectorAll('scala-cart-button').forEach((host) => {
      const root = host.shadowRoot;
      if (!root) return;
      resolveSlot();
      root.querySelectorAll('button, a, [role="button"]').forEach(guardEl);
      if (!host.dataset.collinoShadowObserved) {
        host.dataset.collinoShadowObserved = 'true';
        new MutationObserver(() => applyFix()).observe(root, { childList: true, subtree: true });
      }
    });
  };

  // Queda algo por resolver si hay una botonera cuyo hueco sigue reservado. Cubre
  // los dos casos en los que applyFix no puede hacer nada todavia: que el host de
  // Scala aun no exista, y que exista con el shadowRoot vacio.
  const quedaPendiente = () =>
    !!document.querySelector('[data-cart-drawer-buttons]:not(.scala-resolved)');

  // El shadow root de Scala se llena despues de la inyeccion SIN mutar el drawer,
  // asi que el MutationObserver no se entera: hace falta un barrido por tiempo.
  // Es acotado (10s) y barato (querySelectorAll dentro del drawer).
  let interval = null;
  const barrer = () => {
    if (interval) return; // no apilar barridos
    let tries = 0;
    interval = setInterval(() => {
      tries++;
      applyFix();
      if (tries >= 10) {
        clearInterval(interval);
        interval = null;
        // Se acabo el barrido: se colapsa el hueco pase lo que pase. Si el boton
        // llego, applyFix ya lo colapso y esto no hace nada. Si no llego, a los
        // 10s la reserva ya no tiene sentido y dejarla seria un vacio permanente.
        // Sin condicion a proposito: antes se chequeaba que el elemento NO
        // existiera, y eso dejaba afuera el caso de que exista con el shadowRoot
        // vacio (applyFix sale antes de resolver) -> hueco para siempre.
        resolveSlot();
      }
    }, 1000);
  };

  const start = () => {
    // El boton de Scala solo vive dentro del drawer: se observa SOLO ese subarbol
    // (no document.body) para no correr el callback en cada mutacion de la pagina.
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    if (drawer.dataset.collinoScalaInitialized === 'true') return;
    drawer.dataset.collinoScalaInitialized = 'true';
    applyFix();

    // El barrido se REARMA cada vez que cambia el contenido del drawer, no solo
    // al cargar la pagina. Antes arrancaba una sola vez en DOMContentLoaded y
    // moria a los 10s: si el visitante llegaba con el carrito VACIO -- el caso
    // normal de una primera visita -- esos 10s corrian sin nada que encontrar,
    // porque con el carrito vacio no se renderiza ni la botonera ni el boton de
    // Scala. Cuando despues agregaba su primer producto, el drawer se re-renderiza
    // por Section Rendering API y Scala tiene que inyectar de nuevo; si su
    // shadowRoot terminaba de llenarse un instante despues de la mutacion,
    // applyFix salia sin hacer nada y ya no quedaba ningun reintento vivo. El
    // boton no aparecia hasta recargar. Rearmarlo cierra esa ventana.
    new MutationObserver(() => {
      applyFix();
      if (quedaPendiente()) barrer();
    }).observe(drawer, { childList: true, subtree: true });

    barrer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();

// Agregado directo al carrito (cross-sell del drawer + quick-add de cards).
// Delegado en document: el contenido del drawer se re-renderiza en cada update.
if (!window.__collinoCartQuickAddBound) {
  window.__collinoCartQuickAddBound = true;
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-collino-add]');
    if (!btn || btn.classList.contains('loading')) return;
    event.preventDefault();

    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');

    const formData = new FormData();
    formData.append('id', btn.dataset.variantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer,cart-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) return;

        const drawer = document.getElementById('Cart-Drawer');
        const drawerHtml = response.sections && response.sections['cart-drawer'];
        if (drawer && drawerHtml) {
          const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('.cart-drawer');
          if (parsed) drawer.innerHTML = parsed.innerHTML;
          if (typeof drawer.open === 'function') drawer.open();
          if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
        }

        const bubbleHtml = response.sections && response.sections['cart-bubble'];
        const toggle = document.getElementById('cart-drawer-toggle');
        if (toggle && bubbleHtml) {
          const parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          ['.thb-secondary-area--item-count', '.thb-secondary-area--item-amount'].forEach((selector) => {
            const target = toggle.querySelector(selector);
            const source = parsedBubble.querySelector(selector);
            if (target && source) target.innerHTML = source.innerHTML;
          });
        }

        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        }
      })
      .catch((e) => console.error(e))
      .finally(() => {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  });
}

const initCartDrawerVisualState = function (root = document) {
  const cartDrawer = root.matches?.('#Cart-Drawer') ? root : root.querySelector?.('#Cart-Drawer') || document.getElementById('Cart-Drawer');
  if (!cartDrawer) return;
  if (cartDrawer.dataset.collinoVisualInitialized === 'true') return;
  cartDrawer.dataset.collinoVisualInitialized = 'true';

  const syncVisual = () => {
    cartDrawer.classList.toggle('open', !cartDrawer.hasAttribute('inert'));
  };

  new MutationObserver(syncVisual).observe(cartDrawer, {
    attributes: true,
    attributeFilter: ['inert']
  });
  syncVisual();

  cartDrawer.addEventListener('click', (event) => {
    if (!event.target.closest('.drawer__close-btn')) return;
    if (typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    } else {
      cartDrawer.setAttribute('inert', '');
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCartDrawerVisualState());
} else {
  initCartDrawerVisualState();
}

document.addEventListener('shopify:section:load', (event) => {
  initCartDrawerVisualState(event.target);
});

// Restauracion desde bfcache. Al volver con el boton Atras a una pagina que se
// renderizo ANTES del ultimo agregado, el navegador reusa el DOM congelado: el
// carrito real (cart.js) esta bien, pero el contador del header dice "CARRITO 0" y
// el drawer muestra "Tu carrito esta vacio" con el producto adentro. Medido en el
// recorrido mas comun de mobile: home -> ficha -> agregar -> Atras. No se
// autocorregia (verificado a +3s y +9s).
//
// Volvemos a pedir las mismas dos secciones que pide el add y las reaplicamos. Se
// usa innerHTML igual que en el resto del archivo porque es HTML renderizado por
// Shopify (Section Rendering API), no dato de usuario.
const rehydrateCartFromBfcache = function () {
  const url = new URL(window.location.href);
  url.searchParams.set('sections', 'cart-drawer,cart-bubble');

  fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then((response) => (response.ok ? response.json() : null))
    .then((sections) => {
      if (!sections) return;

      const drawer = document.getElementById('Cart-Drawer');
      const drawerHtml = sections['cart-drawer'];
      if (drawer && drawerHtml) {
        const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('.cart-drawer');
        // Solo el contenido: no lo abrimos ni tocamos su estado de apertura.
        if (parsed) {
          drawer.innerHTML = parsed.innerHTML;
          // La clase cart-drawer--empty vive en el HOST <cart-drawer>, no adentro
          // del innerHTML, asi que reemplazar el contenido no la actualizaba: el
          // drawer volvia con el producto listado pero seguia marcado como vacio.
          // Hoy ninguna regla CSS la usa, pero app.js:474 la togglea, asi que es
          // el mismo contrato y dejarla mentir es una mina para el proximo que la
          // lea. Medido en vivo el 2026-08-10.
          drawer.classList.toggle('cart-drawer--empty', parsed.classList.contains('cart-drawer--empty'));
        }
        if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
      }

      const bubbleHtml = sections['cart-bubble'];
      const toggle = document.getElementById('cart-drawer-toggle');
      if (toggle && bubbleHtml) {
        const parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        ['.thb-secondary-area--item-count', '.thb-secondary-area--item-amount'].forEach((selector) => {
          const target = toggle.querySelector(selector);
          const source = parsedBubble.querySelector(selector);
          if (target && source) target.innerHTML = source.innerHTML;
        });
      }
    })
    .catch(() => {});
};

// Volver con Atras tiene DOS caminos, no uno, y el guard viejo solo cubria el
// primero:
//
//   1. bfcache: el navegador devuelve el DOM congelado -> event.persisted true.
//   2. cache HTTP: el navegador RECONSTRUYE la pagina desde una respuesta
//      cacheada -> event.persisted FALSE, pero el HTML es viejo igual.
//
// En el caso 2 el listener ni siquiera sobrevive a la salida: la pagina se
// arma de nuevo. Con la condicion vieja (solo persisted) no se rehidrataba
// nunca y quedaba el contador del header en el valor viejo: el visitante
// agregaba un producto, volvia con Atras y veia "CARRITO 0" con el carrito
// lleno de verdad. Solo se arreglaba recargando.
//
// Medido el 2026-08-13: al volver, navigation.type era "back_forward" y
// persisted false. Por eso el intento anterior de reproducirlo desde el MCP
// habia dado siempre bien: ahi cada navegacion se resolvia como "navigate", o
// sea red, y el servidor devolvia el contador correcto.
//
// Se agrega el segundo camino usando el tipo de navegacion. Rehidratar de mas
// es barato (una request a sections que se descarta si no cambio nada); no
// rehidratar deja al cliente creyendo que perdio el carrito.
const vinoDeAtrasOAdelante = () => {
  const nav = performance.getEntriesByType('navigation')[0];
  if (nav && nav.type === 'back_forward') return true;
  // Fallback para navegadores sin Navigation Timing 2 (deprecado, pero es el
  // unico dato disponible ahi).
  return performance.navigation && performance.navigation.type === 2;
};

window.addEventListener('pageshow', (event) => {
  if (event.persisted || vinoDeAtrasOAdelante()) rehydrateCartFromBfcache();
});
